<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="references-1">
<h1>References</h1>
<p><strong>Fay MJ et al (2015):</strong> Xenobiotic metabolism in mice lacking the UDP-glucuronosyltransferase 2 family. Drug Metab Dispos; 43: 1838 – 46. <a href="http://dmd.aspetjournals.org/content/early/2015/09/09/dmd.115.065482.long" target="_blank">Free article</a><span class="underline">.</span></p>
<p><strong>Kopot A (2014):</strong> <a href="http://www.aklectures.com/subject/biology" target="_blank">AK lectures on biology</a>.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch010.vue?6b9c08e8